<template>
  <div class="licenses">
  <h1>Verwendete Software und Lizenzen</h1>
      <v-data-table :headers="headers" :items="usedsw"  class="elevation-3" hide-default-footer disable-pagination>
        <template v-slot:[`item.sw`]="{item}">
          <div>{{ item.sw }}</div>
        </template>
        <template v-slot:[`item.liz`]="{item}">
          <div><a :href='item.lizlink'>{{ item.liz }}</a></div>
        </template>
      </v-data-table>
 </div>
</template>
<script>

export default {
  name: 'licenses',
  data: () => ({ 
    usedsw: [
      {sw:"@babel/eslint-parser", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"@firebase/app", liz:"Apache 2.0", lizlink:"https://opensource.org/licenses/Apache-2.0" },
      {sw:"@firebase/auth", liz:"Apache 2.0", lizlink:"https://opensource.org/licenses/Apache-2.0" },
      {sw:"@firebase/firestore", liz:"Apache 2.0", lizlink:"https://opensource.org/licenses/Apache-2.0" },
      {sw:"@vue/cli", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"core-js", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"deploy", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"es6", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"es6-promise", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"firebase", liz:"Apache 2.0", lizlink:"https://opensource.org/licenses/Apache-2.0" },
      {sw:"firebase-auth", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"firebase-functions", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"firebase-tools", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"jspdf", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"node-telegram-bot-api", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"qrcode", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"vue", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"vue-clickaway", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"vue-firestore", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"vue-material", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"vue-router", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"vue-tour", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"vuefire", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
      {sw:"vuetify", liz:"MIT", lizlink:"https://opensource.org/licenses/MIT" },
    ],
    headers: [
      {text: 'Software', value: 'sw', align: 'left'},
      {text: 'Lizenz', value: 'liz', align: 'left'},
    ],
  })
}
</script>
